import IntlMessages from '../util/IntlMessages'
import { MOBILE } from './regex'

const telFormat = (mobile) => {
    if (typeof mobile !== 'undefined' && !MOBILE.test(mobile)) return ''
    else return 'tel:0' + mobile.substr(-10)
}

const getHttpRequestUrl = (serviceName) =>
    process.env.REACT_APP_API_URL + serviceName

const logger = (data, type = 'log') => {
    switch (type) {
        case 'log':
            console.log(JSON.stringify(data))
            break;
        case 'info':
            console.info(JSON.stringify(data))
            break;
        default:
            console.log(JSON.stringify(data))
            break;
    }
}

const getCategoryDetailsTitle = (id) => {
    switch (id) {
        case "1":
            return <IntlMessages id="introduction" />
        case "2":
            return <IntlMessages id="what_wrestler_should_know" />
        case "3":
            return <IntlMessages id="technique" />
        case "4":
            return <IntlMessages id="sport_pathology" />
        case "5":
            return <IntlMessages id="bodybuilding_training" />
        case "6":
            return <IntlMessages id="nutrition_sports_supplements" />
        case "7":
            return <IntlMessages id="practice_with_kesh" />
        case "8":
            return <IntlMessages id="warm_up_exercises" />
        case "9":
            return <IntlMessages id="psychology_motivation" />
        case "10":
            return <IntlMessages id="shading" />
        case "11":
            return <IntlMessages id="competitions" />
        case "12":
            return <IntlMessages id="athletes_sexual_issues" />
        case "31":
            return <IntlMessages id="technique_undercover" />
        case "32":
            return <IntlMessages id="technique_guarding" />
        case "33":
            return <IntlMessages id="technique_yekdast_yekpa" />
        case "34":
            return <IntlMessages id="technique_undercover_continue" />
        case "35":
            return <IntlMessages id="technique_prevalence" />
        case "36":
            return <IntlMessages id="technique_interception_defense" />
        case "37":
            return <IntlMessages id="technique_head_and_neck" />
        case "38":
            return <IntlMessages id="technique_working_hands" />
        case "39":
            return <IntlMessages id="technique_sitting_on_buttocks" />
        case "310":
            return <IntlMessages id="technique_techniques_in_soil" />
        case "311":
            return <IntlMessages id="technique_standing_techniques" />
        default:
            break;
    }
}

const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };
  
export {
    logger,
    telFormat,
    getHttpRequestUrl,
    clearCacheData,
    getCategoryDetailsTitle
}